module.exports = __webpack_public_path__ + "static/media/mini-signal.c3b269f5.svg";